<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">{{ $t('view')}} {{$tc('checklist', 1)}} {{$tc('category', 1)}}</div>
      <router-link
        class="btn-blue"
        :to="{name:'Checklist Categories'}"
      >{{ $tc('category', 2)}} {{ $tc('list', 1)}}</router-link>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Category Name:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{category_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Category Description:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{category_description}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Category is active:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{category_is_active}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChecklistService from "@/services/ChecklistService";

export default {
  data() {
    return {
      category_name: "",
      category_description: "",
      category_is_active: ""
    };
  },
  mounted() {
    this.getCategoryData();
  },
  methods: {
    getCategoryData() {
      const { cc_id } = this.$route.params;
      ChecklistService.GetCategory({ cc_id: cc_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              (this.category_name = data.Records[0].cc_name),
                (this.category_description = data.Records[0].cc_description),
                (this.category_is_active = data.Records[0].cc_is_active = "Y"
                  ? "Yes"
                  : "No");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CheckListCategoriesComponents/viewChecklistCategory.vue